import { api } from './api';

export const activitySetupApi = api.injectEndpoints({
    endpoints: (builder) => ({
        // common
        getActivitySetupList: builder.query({
            query: (payload) => ({
                url: 'api/activity-log/setup/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'LIST'
                }
            }),
            providesTags: ['ActivitySetupList']
        }),
        getAllActivitySetup: builder.query({
            query: (payload) => ({
                url: 'api/activity-log/setup/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'LIST_ALL'
                }
            }),
            providesTags: ['ActivitySetupList']
        }),
        getActivitySetup: builder.query({
            query: ({ payload, subType }) => ({
                url: 'api/activity-log/setup/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: subType
                }
            }),
            providesTags: ['ActivitySetupList']
        }),
        updateActiveActivitySetup: builder.mutation({
            query: (payload) => ({
                url: 'api/activity-log/setup/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'UPDATE_ACTIVITY_LOG_SETUP_STATUS'
                }
            }),
            invalidatesTags: ['ActivitySetupList']
        }),
        updateActivitySetupPermission: builder.mutation({
            query: (payload) => ({
                url: 'api/activity-log/setup/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'permissions_and_approval'
                }
            }),
            invalidatesTags: ['ActivitySetupList', 'ActivitySetupDropdownList']
        }),
        createActivitySetup: builder.mutation({
            query: (payload) => ({
                url: 'api/activity-log/setup/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'CREATE'
                }
            }),
            invalidatesTags: ['ActivitySetupList', 'ActivitySetupDropdownList']
        }),

        getActivitySetupDropDown: builder.query({
            query: (payload) => ({
                url: 'api/activity-log/setup/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'LIST_DROPDOWN'
                }
            }),
            providesTags: ['ActivitySetupDropdownList']
        }),

        getMasterActivitySetup: builder.query({
            query: (payload) => ({
                url: 'api/activity-log/setup/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'LIST_MASTERED_ACTIVITY'
                }
            })
            // providesTags: ['ActivitySetupList']
        }),

        getPayrollClassification: builder.query({
            query: (payload) => ({
                url: 'api/activity-log/setup/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'LIST_PAYROLL_CLASSIFICATION'
                }
            })
            // providesTags: ['ActivitySetupList']
        }),

        getActivitySetupDetails: builder.query({
            query: (payload) => ({
                url: 'api/activity-log/setup/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'DETAIL'
                }
            }),
            providesTags: ['ActivitySetupetails']
        }),

        addActivitySetupDetails: builder.mutation({
            query: (payload) => ({
                url: '/api/activity-log/setup/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: payload.emp_id ? 'UPDATE' : 'CREATE'
                }
            }),
            // providesTags: ['EmployeeList', 'EmployeeDetails']
            invalidatesTags: (result, error, arg) => (result ? ['EmployeeDetails'] : [])
        }),

        deleteActivitySetup: builder.mutation({
            query: (payload) => ({
                url: 'api/activity-log/setup/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'REMOVE'
                }
            }),
            invalidatesTags: ['ActivitySetupList']
        }),

        deleteActivityEntry: builder.mutation({
            query: (payload) => ({
                url: 'api/activity-log/time-entry',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'delete'
                }
            })
            // invalidatesTags: ['ActivitySetupList']
        }),

        getActivitySetupHistory: builder.query({
            query: (payload) => ({
                url: 'api/activity-log/setup/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'ACTIVITY'
                }
            }),
            invalidatesTags: ['ActivitySetupHistory']
        }),

        createActivityTime: builder.mutation({
            query: (payload) => ({
                url: 'api/activity-log/time-entry',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'CREATE'
                }
            })
            // invalidatesTags: ['ActivityTimeDetails']
        }),
        updateActivityTime: builder.mutation({
            query: (payload) => ({
                url: 'api/activity-log/time-entry',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'update'
                }
            })
            // invalidatesTags: ['ActivityTimeDetails']
        }),
        getActivityTimeDetails: builder.query({
            query: (payload) => ({
                url: 'api/activity-log/time-entry',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'detail'
                }
            })
            // providesTags: ['ActivityTimeDetails']
        }),
        eActivitySign: builder.mutation({
            query: (payload) => ({
                url: 'api/activity-log/time-entry',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'esign'
                }
            })
            // invalidatesTags: (result, error, arg) => (result ? ['SessionList', 'SessionDetails', 'UnsignedReportsList'] : [])
        })
    })
});

export const {
    useGetActivitySetupListQuery,
    useGetAllActivitySetupQuery,
    useGetActivitySetupQuery,
    useUpdateActiveActivitySetupMutation,
    useUpdateActivitySetupPermissionMutation,
    useCreateActivitySetupMutation,
    useCreateActivityTimeMutation,
    useUpdateActivityTimeMutation,

    useGetActivitySetupDropDownQuery,
    useGetMasterActivitySetupQuery,
    useGetPayrollClassificationQuery,
    useGetActivitySetupDetailsQuery,
    useDeleteActivitySetupMutation,
    useDeleteActivityEntryMutation,

    useGetActivitySetupHistoryQuery,
    useLazyGetActivityTimeDetailsQuery,
    useEActivitySignMutation
} = activitySetupApi;
